import { Switch, Route, Redirect } from 'react-router';
import { ERoutes } from '../../util/constants';
import { FC, useContext } from 'react';
import { Alert, Stack } from '@mui/material';
import GlobalContext from '../../contexts/GlobalContext';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Loader } from '../../components/Loader/Loader';
import MigrateToExistingAccountContext, {
    MigrateToExistingAccountProvider,
    EMigrateToExistingAccountUiState,
} from '../../contexts/MigrateToExistingAccountContext';
import MigrateToExistingAccountForm from '../../components/MigrateToExistingAccountForm/MigrateToExistingAccountForm';
import MigrateToExistingAccountConfirm from '../../components/MigrateToExistingAccountConfirm/MigrateToExistingAccountConfirm';

const MigrateExistingAccountRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.migrateToExistingAccount}>
                <MigrateToExistingAccountForm />
            </Route>
            <Route exact path={ERoutes.migrateToExistingAccountSuccess}>
                <MigrateToExistingAccountConfirm />
            </Route>
        </Switch>
    );
};

const MigrateToExistingAccountUi: FC = () => {
    const { language } = useContext(GlobalContext);
    const { migrateToExistingAccountUiState } = useContext(MigrateToExistingAccountContext);
    switch (migrateToExistingAccountUiState) {
        case EMigrateToExistingAccountUiState.default:
            return (
                <PageLayoutV2>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
        case EMigrateToExistingAccountUiState.ready:
            return <MigrateExistingAccountRouter />;
        case EMigrateToExistingAccountUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.migrateToExistingAccountSuccess} />
                    <MigrateExistingAccountRouter />
                </>
            );
        case EMigrateToExistingAccountUiState.notInitialized:
            return <Redirect to={ERoutes.login} />;
        default:
            return (
                <>
                    {console.error(`Migrate account ui state set incorrectly -- ${migrateToExistingAccountUiState}`)}
                    <Alert severity="error">{language.error.generic}</Alert>
                </>
            );
    }
};

const MigrateToExistingAccountScreen: FC = () => {
    return (
        <MigrateToExistingAccountProvider>
            <PageLayoutV2>
                <MigrateToExistingAccountUi />
            </PageLayoutV2>
        </MigrateToExistingAccountProvider>
    );
};

export default MigrateToExistingAccountScreen;
